import { DashboardEligibleProduct } from 'codegen';
import { TColumn } from 'types';

export const columns: TColumn<DashboardEligibleProduct>[] = [{
  type: TColumn.type.Ellipsis,
  width: 250,
  title: 'Product Name',
  dataIndex: 'productName',
}, {
  type: TColumn.type.Tags,
  width: 250,
  title: 'SKUs',
  dataIndex: 'supportedSkus',
}, {
  type: TColumn.type.Tags,
  title: 'Names',
  dataIndex: 'supportedLineItemNames',
}];
